module.exports = __webpack_public_path__ + "static/urban8-9ee04ebb40ca1e78189149bb030acded.jpg";